@if (displayedValue() | propertyTranslator; as value) {
  <span
    [appOverlayHoverOpener]="tooltipPopover"
    [tabindex]="tabIndex()"
    class="tooltip-container {{ styleClass() }}"
  >
    <i class="tooltip__icon color-primary" [ngClass]="icon()"></i>
  </span>

  <p-popover
    #tooltipPopover
    styleClass="tooltip-primary description-tooltip rounded-0 max-30"
  >
    @if (isArray(value)) {
      <div class="whitespace-normal break-words text-wrap max-w-xs">
        @for (section of asArray(value); track $index) {
          @if ($any(section).title) {
            <h6
              class="font-semibold text-sm mb-2 border-b border-gray-200 pb-1"
            >
              {{ $any(section).title }}
            </h6>
          }

          @if ($any(section).items && isArray($any(section).items)) {
            <ul class="list-disc list-inside mb-3 space-y-1">
              @for (item of $any(section).items; track $index) {
                <li class="text-xs">{{ item }}</li>
              }
            </ul>
          } @else if ($any(section).content) {
            <p class="text-xs mb-3">{{ $any(section).content }}</p>
          } @else {
            <p class="text-xs mb-3">{{ section }}</p>
          }

          @if (!$last) {
            <hr class="border-gray-200 my-2" />
          }
        }
      </div>
    } @else {
      <p class="whitespace-pre-line break-words text-wrap max-w-xs">
        {{ value }}
      </p>
    }
  </p-popover>
}
